import axios from 'axios';
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';
import DateInput from '../Common-Components/DateInput';
import FileInput from '../Common-Components/FileInput';
import Input from '../Common-Components/Input';
import TinyEditor from '../Common-Components/TinyEditor';
import { getTestSeries, setDropDownStyle } from '../CommonHelper';
import BatchInput from '../Course/BatchInput';
import '../Course/Course.css';
import { generateUniqueID, getExamTypes, getFaculties, getTypes } from '../Course/CourseHelper';
import { checkExistingItem } from '../common-helpers/commonServices';
import { fetchTestData, formateTestData } from './TestHelper';
import DropdownInput from '../Common-Components/DropdownInput';

let initialFormData = {
    examType: 'Select Exam Type',
    examTypeId: 0,
    sNo: 0,
    title: '',
    language: 'English',
    titleHeading: '',
    price: 0,
    seatBookingPrice: 0,
    discount: 0,
    appDiscount: 0,
    type: 'Select Type',
    typeId: 0,
    // topicCount: 0,
    duration: 0,
    faculty: 'Select Faculty',
    facultyId: 0,
    subscriptionCount: 0,
    currentBatchID: 0,
    description: '',
    imageURL: '',
    pdfURL: '',
    syllabusPDFURL: '',
    topics: '',
    tags: '',
    demoVideoLink: '',
    metaTitle: '',
    metaDescription: '',
    courseId: '',
    secondCourseId: '',
    secondCourseTitle: 'Select Other Test Series',
    startDate: new Date(),
    admissionStartDate: new Date(),
    mcqRules: '',
    quizCount: 0,
    subjectiveRules: ''
}
const TestModal = forwardRef((props, ref) => {
    const [modalBox, setModalBox] = useState(false);
    const [testId, setTestId] = useState('');
    const [updatingTestId, setUpdatingTestId] = useState(0);
    const [examTypesArray, setExamTypesArray] = useState([]);
    const [typesArray, setTypesArray] = useState([]);
    const [TypesToDisplay, setTypesToDisplay] = useState([]);
    const [facultyArray, setFaculties] = useState([])
    const [formData, setFormData] = useState(initialFormData);
    const [updatingDataReady, setUpdatingDataReady] = useState(false);
    const [allTestSeries, setAllTestSeries] = useState([]); 
    const [testSeries, setTestSeries] = useState([]);
    console.log(formData)
    // console.log(examTypesArray)
    //check for existing items       
    const [itemAlreadyExist, setItemAlreadyExists] = useState(false);
    const [currentTitle, setCurrentTitle] = useState('');//for updating 
    useEffect(() => {
        if (formData.title && currentTitle.toLowerCase().trim() != formData.title.toLowerCase().trim()) { // current title is for updating case
            let timer = setTimeout(() => {
                checkExistingItem('QuizMaster', 'Title', formData.title).then(response => { //tablename and columnNane value
                    setItemAlreadyExists(response)
                })

            }, 500);
            return () => clearTimeout(timer);
        }

    }, [formData.title]);

    useEffect(() => {
        console.log(formData.examTypeId)
        let filteredTypes = typesArray?.filter(obj => obj.examBodies?.includes(formData.examTypeId))
        console.log(filteredTypes)
        setTypesToDisplay(filteredTypes)
    }, [formData.examTypeId])
    useEffect(() => {
        // Filter opposite language test series
        if (formData.language === 'Hindi') {
            setTestSeries(allTestSeries.filter(data => data.language !== 'Hindi'));
        } else {
            setTestSeries(allTestSeries.filter(data => data.language !== 'English'));
        }
    }, [formData.language, allTestSeries]);

    useImperativeHandle(ref, () => ({
        openModal(CourseID) {
            getTypes().then((res) => {
                setTypesArray(res.filter(type => type.moduleType == 'test-series'));
            })
            getExamTypes().then((res) => {
                setExamTypesArray(res);
            })
            getFaculties().then((res) => {
                setFaculties(res);
            })
            getTestSeries().then((res) => {
                // res.unshift({ title: "Select Other Test Series" })
                setAllTestSeries(res);
                // setTestSeries(res)
            })

            if (CourseID) {
                setUpdatingTestId(CourseID)
                setTestId(CourseID)
                fetchTestData(CourseID).then((test) => {
                    formateTestData(test).then(formatedData => {
                        if (formatedData.title) {
                            setCurrentTitle(formatedData.title)
                            console.log(formatedData)
                            setFormData(formatedData)
                            setUpdatingDataReady(true)
                            //  setModalBox(true);
                        }
                    })

                })
            } else {
                setFormData(initialFormData)
                let courseId = generateUniqueID();
                setTestId(courseId);
                handleChange('courseId', courseId)//property name and value   
                // setModalBox(true);
            }
            setModalBox(true);

        }
    }));

    const handleChange = (name, value) => {
        setFormData((formData) => (
            { ...formData, [name]: value }
        ));
    };

    console.log(formData)
    const handleSubmitTest = () => {
        /* let errorMessgae = validateTestData(formData)
        console.log(errorMessgae)
        if (errorMessgae) {
            toast.error(errorMessgae)
            return;
        } else */

        if (formData.examTypeId < 1) {
            toast.error('Please Select Exam Type')
            return;
        } else if (formData.typeId < 1) {
            toast.error('Please Select Type')
            return;
        }
        if (itemAlreadyExist && currentTitle.toLowerCase().trim() != formData.title.toLowerCase().trim()) {
            toast.error("Topic Already Exists")
            return;
        }
        axios.post(BACKEND_SERVER_URL + (updatingTestId ? `/editTest/${updatingTestId}` : '/createTest'), formData).then((response) => {
            if (response.data.statusCode == 201) {
                setFormData(initialFormData)
                toast.success(response.data.message)
                props.setCourseLoading(!props.loadCourses)
                setModalBox(false);
            }
        }).catch((error) => {
            toast.error(error.response.data.message)
            console.log(error)
        })

    }
    useEffect(() => {
        if (!modalBox) {
            setUpdatingTestId(0);
            setFormData(initialFormData); // Reset form data when modal is closed
            setItemAlreadyExists(false)
            setCurrentTitle('')
        }
    }, [modalBox]);
    return (
        <>
            <Modal className="" show={modalBox} onHide={setModalBox} dialogClassName="custom-modal-width" backdrop="static"
                keyboard={false} >
                <Modal.Header>
                    <Modal.Title>{updatingTestId ? 'Update Test Series' : 'Create Test Series'}</Modal.Title>
                    <Button variant="" className="btn-close" onClick={() => setModalBox(false)}></Button>
                </Modal.Header>
                <Modal.Body>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12 d-flex justify-content-around  ">
                                <div className="col-5 d-flex ">
                                    <DropdownInput handleChangeCallBack={handleChange} labelName="Language" selectedValue={formData?.language} inputName='language' dropdownValuesArray={['English', 'Hindi']} />
                                </div>
                                <div className="col-5 d-flex">
                                    <div className="col-sm-4 pt-2">
                                        <div className="mb-3" >
                                            <label htmlFor='news' className="form-label text-primary">Other Language T.S</label>
                                        </div>
                                    </div>
                                    <div className="col-sm-8">
                                        <div className="mb-3">
                                            <Select
                                                value={{ value: formData.secondCourseTitle, label: formData.secondCourseTitle || 'Select Other Test Series' }}
                                                onChange={(selectedOption) => setFormData({ ...formData, secondCourseId: selectedOption.value.courseId, secondCourseTitle: selectedOption.value.title, secondCourseTitleURL: selectedOption.value.titleURL })}
                                                options={testSeries?.map((item) => ({ value: item, label: item.title }))}
                                                styles={setDropDownStyle()}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-around ">
                                <div className="col-5 d-flex">
                                    <div className="col-sm-4 pt-2">
                                        <div className="mb-3" >
                                            <label htmlFor='news' className="form-label text-primary">Exam Type</label>
                                        </div>
                                    </div>
                                    <div className="col-sm-8">
                                        <div className="mb-3">
                                            <Select
                                                value={{ value: formData.examType, label: formData.examType }}
                                                onChange={(selectedOption) => setFormData({ ...formData, examTypeId: selectedOption.value.Sn, examType: selectedOption.value.exambody })}
                                                options={examTypesArray?.map((item) => ({ value: item, label: item.exambody }))}
                                                styles={setDropDownStyle()}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-5 d-flex">
                                    <Input handleChangeCallBack={handleChange} labelName="S. No." inputType="number" inputValue={formData?.sNo} inputName='sNo' divSizes={[4, 8]} />
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-around ">
                                <div className="col-5 d-flex">
                                    <Input inputType="text" handleChangeCallBack={handleChange} labelName="Title" inputValue={formData?.title} inputName='title' divSizes={[4, 8]} />
                                </div>
                                <div className="col-5 d-flex">
                                    <Input inputType="text" handleChangeCallBack={handleChange} labelName="Title Heading" inputValue={formData?.titleHeading} inputName='titleHeading' divSizes={[4, 8]} />
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-around">
                                <div className="col-5 d-flex">
                                    <Input handleChangeCallBack={handleChange} labelName="Price" inputType="number" inputValue={formData?.price} inputName='price' divSizes={[4, 8]} />
                                </div>
                                <div className="col-5 d-flex">
                                    <Input handleChangeCallBack={handleChange} labelName="Seat Booking Price" inputType="number" inputValue={formData?.seatBookingPrice} inputName='seatBookingPrice' divSizes={[4, 8]} />
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-around  ">
                                <div className="col-5 d-flex">
                                    <Input handleChangeCallBack={handleChange} labelName="Discount %" inputType="number" inputValue={formData?.discount} inputName='discount' divSizes={[4, 8]} />
                                </div>
                                <div className="col-5 d-flex">
                                    <Input handleChangeCallBack={handleChange} labelName="App Discount %" inputType="number" inputValue={formData?.appDiscount} inputName='appDiscount' divSizes={[4, 8]} />
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-around  ">
                                <div className="col-5 d-flex">
                                    <div className="col-sm-4 pt-2">
                                        <div className="mb-3" >
                                            <label htmlFor='news' className="form-label text-primary">Type</label>
                                        </div>
                                    </div>
                                    <div className="col-sm-8">
                                        <div className="mb-3">
                                            <Select
                                                value={{ value: formData.type, label: formData.type }}
                                                onChange={(selectedOption) => setFormData({ ...formData, typeId: selectedOption.value.sn, type: selectedOption.value.courseType })}
                                                options={TypesToDisplay?.map((item) => ({ value: item, label: item.courseType }))}
                                                styles={setDropDownStyle()}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-5 d-flex ">
                                    <Input handleChangeCallBack={handleChange} labelName="Test Series ID" inputType="text" inputValue={formData?.courseId || testId} inputName='courseId' divSizes={[4, 8]} />
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-around  ">
                                <div className="col-5 d-flex">
                                    <Input handleChangeCallBack={handleChange} labelName="Quiz Count" inputValue={formData?.quizCount} inputName='quizCount' inputType="number" divSizes={[4, 8]} />
                                </div>
                                <div className="col-5 d-flex">
                                    <Input handleChangeCallBack={handleChange} labelName="Duration" inputValue={formData?.duration} inputName='duration' inputType="number" divSizes={[4, 8]} />
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-around  ">
                                <div className="col-5 d-flex">
                                    <div className="col-sm-4 pt-2">
                                        <div className="mb-3" >
                                            <label htmlFor='news' className="form-label text-primary">Faculty</label>
                                        </div>
                                    </div>
                                    <div className="col-sm-8">
                                        <div className="mb-3">
                                            <Select
                                                value={{ value: formData.faculty, label: formData.faculty }}
                                                onChange={(selectedOption) => setFormData({ ...formData, facultyId: selectedOption.value.sn, faculty: selectedOption.value.facultyName })}
                                                options={facultyArray?.map((item) => ({ value: item, label: item.facultyName }))}
                                                styles={setDropDownStyle()}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-5 d-flex">
                                    <Input handleChangeCallBack={handleChange} labelName="Subscription Count" inputType="number" inputValue={formData?.subscriptionCount} inputName='subscriptionCount' divSizes={[4, 8]} />
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-around  ">
                                <div className="col-5 d-flex align-items-center">
                                    <DateInput labelName="Start Date" selected={formData?.startDate} handleChangeCallBack={handleChange} inputName='startDate' />
                                </div>
                                <div className="col-5 d-flex align-items-center">
                                    <DateInput labelName="Admission Start Date" selected={formData?.admissionStartDate} handleChangeCallBack={handleChange} inputName='admissionStartDate' />
                                </div>
                            </div>
                            <div className="col-12 d-flex  justify-content-between mt-3">
                                <BatchInput handleChangeCallBack={handleChange} labelName="Add Batch" courseId={testId} inputValue={formData?.currentBatchID} inputName='currentBatchID' moduleName="testPage" updating={updatingTestId} />
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <TinyEditor handleChangeCallBack={handleChange} labelName="Description" inputValue={formData?.description} inputName='description' />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <TinyEditor handleChangeCallBack={handleChange} labelName="MCQ Rules" inputValue={formData?.mcqRules} inputName='mcqRules' />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <TinyEditor handleChangeCallBack={handleChange} labelName="Subjective Rules" inputValue={formData?.subjectiveRules} inputName='subjectiveRules' />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <FileInput handleChangeCallBack={handleChange} labelName="Image" inputType="text" uploadedFileURL={formData?.imageURL} inputName='imageURL' accept="image/jpeg, image/png, image/gif" />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <FileInput handleChangeCallBack={handleChange} labelName="PDF URL" inputType="text" uploadedFileURL={formData?.pdfURL} inputName='pdfURL' accept="pdf" />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <FileInput handleChangeCallBack={handleChange} labelName="Syllabus PDF URL" inputType="text" uploadedFileURL={formData?.syllabusPDFURL} inputName='syllabusPDFURL' accept="pdf" />
                                </div>
                            </div>

                            <div className="col-12 ">
                                <div className="d-flex">
                                    <Input handleChangeCallBack={handleChange} labelName="Topics" inputType="text" inputValue={formData?.topics} inputName='topics' divSizes={[2, 10]} />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <Input handleChangeCallBack={handleChange} labelName="Tags" inputType="text" inputValue={formData?.tags} inputName='tags' divSizes={[2, 10]} />
                                </div>
                            </div>
                            {/* <div className="col-12 ">
                                <div className="d-flex">
                                    <Input handleChangeCallBack={handleChange} labelName="Demo Video Link" inputType="text" inputValue={formData?.demoVideoLink} inputName='demoVideoLink' divSizes={[2, 10]} />
                                </div>
                            </div> */}
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <Input handleChangeCallBack={handleChange} labelName="Meta Title" inputType="text" inputValue={formData?.metaTitle} inputName='metaTitle' divSizes={[2, 10]} />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <Input handleChangeCallBack={handleChange} labelName="Meta Description" inputType="textarea" inputValue={formData?.metaDescription} inputName='metaDescription' divSizes={[2, 10]} />
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger light" className='btn-sm' onClick={() => setModalBox(false)}>Close</Button>
                    <Button variant="primary " className='btn-sm ' onClick={handleSubmitTest}>{updatingTestId ? 'Update' : 'Create'}</Button>
                </Modal.Footer>
            </Modal>


        </>
    )
})
export default TestModal;